import {setInitialState} from '../../../utils/reducerOperations';
export const Default=()=>({
    fetchScoresTableApi:setInitialState(),
});